import axios from "axios";
import { API_URL } from "./apiURL";


let inputData;
export async function getInput(fieldName){
    //console.log("Inside API call for getCRFInput for field : " + fieldName);
     inputData =await axios.get(API_URL+'getInput/'+fieldName); 
     return inputData.data;
}
